<script setup>
import { defineModel, defineProps, defineEmits, computed } from "vue";

const emit = defineEmits(["clear", "search"]);

const props = defineProps({
  placeholder: { type: String, default: "" },
  mode: { type: String, default: "" },
  width: { type: [String, Number], default: "400px" },
  height: { type: [String, Number], default: "46px" },
  searchOnEnter: { type: Boolean, default: false },
});

const modelValue = defineModel({ required: true });

const classes = computed(() => [
  "search-input",
  {
    ["search-input--" + props.mode]: props.mode,
  },
]);

const inputStyle = computed(() => ({
  width: typeof props.width === "number" ? `${props.width}px` : props.width,
  height: typeof props.height === "number" ? `${props.height}px` : props.height,
}));

// function clear() {
//   modelValue.value = "";
//   emit("clear");
// }

function search(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  emit("search", modelValue.value);
}

let timeout = null;
function debounce(func, wait) {
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const debouncedSearch = debounce(search, 500);

function handleInput(event) {
  modelValue.value = event.target.value;
  if (!props.searchOnEnter) {
    debouncedSearch();
  }
}

function handleKeyUp(event) {
  if (event.key === "Enter") {
    search();
  }
}
</script>

<template>
  <div :class="classes">
    <label>
      <input
        v-bind="$attrs"
        :value="modelValue"
        @keyup="handleKeyUp"
        @input="handleInput"
        type="text"
        :placeholder="placeholder"
        :style="inputStyle"
      />

      <svg
        @click="search($event)"
        class="search-input-icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
        />
      </svg>
    </label>
  </div>
</template>

<style scoped>
.search-input label {
  position: relative;
  display: flex;
}

.search-input label input {
  /* border: 1px solid var(--border-color); */
  border: 1px solid #DDE5ED;
  outline: none;
  /* background: var(--body-color); */
  background: #fff;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 16px;
  font-family: OpenSansRegular, sans-serif;
  /* color: var(--text-color); */
  color: #4D5460;
}

.search-input label input::placeholder {
  color: rgb(161, 162, 172);
  opacity: 1;
}

.search-input-icon {
  position: absolute;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  right: 15px;
}

.search-input-icon path {
  fill: #4D5460;
}

.search-input.search-input--big label input {
  width: 350px;
}

.search-input--compact input {
  padding: 4px;
  height: 28px;
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .search-input.search-input--big label input {
    width: 300px;
  }
}

/* < 960 */
@media screen and (max-width: 959px) {
  .search-input.search-input--big label input {
    width: 100%;
  }
}
</style>
